import { Box, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import GlobalButton from "../../../components/CustomButton";
import ProductCard from "../../../components/Cards/ProductCard";

const AttachedProducts = ({
  selectedProducts,
  setSelectedProducts,
  attachedProductsDialogRef,
}) => {
  const { t } = useTranslation(["blog", "common"]);

  const handleRemoveProduct = (product) => {
    setSelectedProducts((prev) =>
      prev.filter((item) => item._id !== product._id)
    );
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 3,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
      >
        <Box>
          <Typography variant="h6" fontWeight={600}>
            {t("attachedProducts", { ns: "blog" })}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {t("optional", { ns: "common" })}
          </Typography>
        </Box>

        <GlobalButton
          btnText="addProducts"
          handleClickBtn={() =>
            attachedProductsDialogRef?.current?.openDialog()
          }
          styleProps={{
            width: "auto",
            minWidth: 180,
          }}
        />
      </Stack>

      {selectedProducts?.length > 0 ? (
        <Box mt={3}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            <Typography variant="body2" color="text.secondary">
              {t("selectedProductsCount", {
                ns: "blog",
                count: selectedProducts.length,
              })}
            </Typography>

            <Chip
              color="primary"
              size="small"
              label={`${selectedProducts.length} Selected`}
            />
          </Stack>

          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "background.default",
            }}
          >
            <Grid container spacing={2}>
              {selectedProducts.map((product) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={product._id}
                >
                  <ProductCard
                    cardData={product}
                    showRemove
                    onRemove={handleRemoveProduct}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box
          mt={3}
          sx={{
            border: "1px dashed",
            borderColor: "divider",
            borderRadius: 2,
            py: 4,
            px: 2,
            textAlign: "center",
            bgcolor: "background.default",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {t("noProductsSelected", { ns: "common" })}
          </Typography>

          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mt={1}
          >
            {t("clickAddProductsToAttachProducts", { ns: "common" })}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default AttachedProducts;